import { atom, PrimitiveAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

import { currentEnv } from '@/env/vars.ts'
import { store } from '@/store'
import { IMimeType, IMimeTypes } from '@/types/documents/File'
import { IDocument } from '@/types/gigiChat/ConversationSettings'
import { DELETE, GET, POST } from '@/utils/fetch'

import { getQuotas } from '../gigiChat/Quotas'

export const filesAtom = atom<IDocument[]>([])
export const uploadInProgress = atom<boolean>(false)
export const searchDocsAtom = atom('')
export const fileExtensionsAtom = atomWithStorage<Array<IMimeType> | null>('fileExtension', null)
export const docsLeftSideExpandedAtom: PrimitiveAtom<boolean> = atom(true)

export const deleteFile = async (fileName: string) => await DELETE(`${currentEnv.chatUrl}/user/docs/${encodeURI(fileName)}`)

export const uploadFiles = async (formData: FormData) => {
    return await POST(`${currentEnv.chatUrl}/user/docs`, formData, true).then((response) => {
        if (response && response.status === 413) {
            void getQuotas()
        }
        return response
    })
}

export const getBaseName = (path: string) => {
    const lastDotIndex = path.lastIndexOf('.')
    return lastDotIndex !== -1 ? path.substring(0, lastDotIndex) : path
}

export const getNextAvailableSuffix = (list: IDocument[], basename: string) => {
    let suffix = 0
    list.forEach((obj) => {
        const base = getBaseName(obj.name)
        if (base.startsWith(basename + '_')) {
            const currentSuffix = parseInt(base.substring(basename.length + 1), 10)
            if (!isNaN(currentSuffix) && currentSuffix > suffix) {
                suffix = currentSuffix
            }
        }
    })
    return suffix + 1
}

export const getUniqueElement = (files: IDocument[], newPath: string) => {
    const newList = files
    const basename = getBaseName(newPath)
    const extension = newPath.includes('.') ? newPath.substring(newPath.lastIndexOf('.')) : ''
    let newElementPath = basename + extension

    if (newList.some((obj) => getBaseName(obj.name) === basename)) {
        const suffix = getNextAvailableSuffix(newList, basename)
        newElementPath = `${basename}_${suffix}${extension}`
    }

    return newElementPath
}

export const getAllowedFileExtensions = async () => {
    const result = await GET<IMimeTypes>(
        `${currentEnv.features.isEnabled('mimeTypesNode') ? currentEnv.coreChatUrl : currentEnv.chatUrl}/system/docs/mime_types`,
    )

    if (result && result.mimeTypes) {
        store.set(fileExtensionsAtom, result.mimeTypes)
    }
}
